export default __webpack_public_path__ + "static/media/Adventure.3eda32a1.svg";